import { Button } from "components"
import { TabRegisterPath } from "../../types/TabRegisterPath"
import { PERMISION } from "security"

type TabRegisterProps = {
  activeTab: string
  setActiveTab: (path: string) => void
}
type Tabs = {
  label: string
  path: TabRegisterPath
  permission: string
}

export function TabNavFind({ activeTab, setActiveTab }: TabRegisterProps) { 
  const tabs: Tabs[] = [
    { label: "Accounts", path: "accounts", permission: PERMISION.ACCOUNTS.FIND.FINANCE.PERMISION },
    { label: "Finance", path: "finance", permission: PERMISION.FINANCE.FIND.FINANCE.PERMISION },
    { label: "Sales", path: "sales", permission: PERMISION.SALES.FIND.SALES.PERMISION },
    { label: "Purchases", path: "purchase", permission: PERMISION.PURCHASES.FIND.PURCHASES.PERMISION },
    { label: "Inventory", path: "inventory", permission: PERMISION.INVENTORY.FIND.INVENTORY.PERMISION },
    { label: "Cards", path: "cards", permission: PERMISION.CARDS.FIND.CARDS.PERMISION },
    { label: "Journals", path: "journals", permission: PERMISION.SUBSCRIBED } /** Hak akses belum di setup karena menu belum di develope */
  ]

  return (
    <section className="grow flex items-stretch overflow-x-auto">
      {tabs.map((tab) => (
        <Button
          key={tab?.path}
          type="button"
          color="ghost"
          size="sm"
          permission={tab?.permission}
          className={`grow bg-[#3c3c3c] border-y-0 border-x border-white no-animation hover:bg-primary hover:text-black whitespace-nowrap uppercase ${tab.path === activeTab ? "bg-primary text-black" : "text-white"}`}
          onClick={() => setActiveTab(tab?.path)}
        >
          {tab.label}
        </Button>
      ))}
    </section>
  )
}
